var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"toggle"},[_c('input',{staticClass:"toggle-checkbox",attrs:{"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.checkedProp(_vm.checked)},on:{"change":_vm.isChecked}}),_c('div',{staticClass:"toggle-switch"}),(_vm.label)?_c('span',{staticClass:"toggle-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }